export class LMCtrlShiftClickEvent extends MouseEvent {
  metaKey: boolean;
  ctrlKey: boolean;
  shiftKey: boolean;
  srcEventElement?: Element;
  isPage?: boolean;
  routeComponent?: any;   // This needs to be LMBaseComponent
  additionInfo?: any;
  originalEvent: Event;
}

// These are added to allow the ctrl-shift-click be able to click on the header bar in IE without causing IE to not fail on load.
// This should be able to be removed when we update to node 14
type CtrlShiftCallback = (evt: Event) => void

interface CtrlShiftListeners {
  [type: string]: Array<CtrlShiftCallback>
}

export class EventTargetPolyfill implements EventTarget {
  listeners?: CtrlShiftListeners = {}

  addEventListener(type: string, callback: CtrlShiftCallback) {
    if (!(type in this.listeners)) {
      this.listeners[type] = []
    }
    this.listeners[type].push(callback)
  }

  removeEventListener(type: string, callback: CtrlShiftCallback) {
    if (!(type in this.listeners)) {
      return
    }
    const stack = this.listeners[type]
    // tslint:disable-next-line one-variable-per-declaration
    for (let i = 0, l = stack.length; i < l; i++) {
      if (stack[i] === callback) {
        stack.splice(i, 1)
        return
      }
    }
  }

  dispatchEvent(event: Event) {
    if (!(event.type in this.listeners)) {
      return true
    }
    const stack = this.listeners[event.type].slice()
    // tslint:disable-next-line one-variable-per-declaration
    for (let i = 0, l = stack.length; i < l; i++) {
      stack[i].call(this, event)
    }
    return !event.defaultPrevented
  }
}

export class CurrentTarget extends EventTargetPolyfill {
  nodeName?: string;
}
